import { Col, Row, Spin, DatePicker, Button, Input } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import AppTable from "../../components/AppTable/AppTable";
import axiosGet from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";

const EnterpriseEnquiry = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [customerList, setCustomerList] = useState([]);
    const [copyCustomerList, setCopyCustomerList] = useState([]);
    const [fromdate, setfromdate]: any = useState(moment());
    const [todayFlag, setTodayFlag] = useState(false);
    const [prevFlag, setPrevFlag] = useState(false);
    const [todate, settodate]: any = useState(moment());
    const dateFormat = "DD/MM/YYYY";
    const [branchid, setbranchid]: any = useState(localStorage.getItem("cityid"));
    const [totalCount, setTotalCount] = useState(0);
    const [appcount, setAppcount] = useState(0);
    const [SearchText, setsearchText]: any = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const disabledDate = (current: any) => {
        // Can not select days before today and today
        return current && current > moment().endOf("day");
    };
    const disabledFromDate = (current: any) => {
        // Can not select days before today and today
        return current && current > moment(todate).endOf("day");
    };
    const onDateSearch = (
        fromdate: any,
        todate: any,

    ) => {
        DateSearch(
            moment(fromdate).format("YYYY/MM/DD"),
            moment(todate).add("days", 1).format("YYYY/MM/DD"),

        );
    };
    const DateSearch = (
        fromdate: any,
        todate: any,

    ) => {
        setIsLoading(true);
        const options: any = {
            params: {
                branchid: branchid,
                fromdate: fromdate,
                todate: todate,

            },
        };
        axiosGet(UrlConstants.getEnterpriseEnquiry, options)
            .then((resp: any) => {
                resp.data.forEach((e: any) => {
                    e.key = e._id.toString();
                });
                setIsLoading(false);
                setCustomerList(resp.data);
                setCopyCustomerList(resp.data);
                setTotalCount(resp.tablelength);
                setAppcount(resp.totalcount)

            })
            .catch(function (error: any) {
                setIsLoading(false);
                if (error.response) {
                    console.log(error.response.data, error.response.status);
                    setCustomerList([]);
                    setCopyCustomerList([]);
                }
            });
    };
    const onSearchchange = (e: any) => {
        setsearchText(e.target.value);
        globalSearch(e.target.value);
    };
    const globalSearch = (searchText: any) => {
        let filteredData = customerList.filter((value: any) => {
            if (value.customername === undefined || value.customername === null) value.customername = "";

            return (
                value.customername
                    .toString()
                    .toLowerCase()
                    .includes(searchText.toLowerCase()) ||
                value.mobileno
                    .toString()
                    .toLowerCase()
                    .includes(searchText.toLowerCase())


            );
        });
        setCopyCustomerList(filteredData);
        setFilteredData(filteredData);
    };
    const columns = [
        {
            title: "E.Enquiry ID",
            dataIndex: "Enterprise_ID",
            key: "ID",
        },
        {
            title: "Date",
            dataIndex: "Addeddate",
            key: "Addeddate",
            render: (text: any) => text ? text.split('T')[0] : '',
        },
        {
            title: "Company Name",
            dataIndex: "CompanyName",
            key: "CompanyName",
        },
        {
            title: "Auth. Person",
            dataIndex: "Authorized_Person",
            key: "AuthPerson",
        },
        {
            title: "Mobile",
            dataIndex: "Mobno",
            key: "mobile",
            render: (text: any) => text ? text.replace(/^\+91/, '') : '',
        },
        {
            title: "Address",
            dataIndex: "Address",
            key: "Address",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Add by",
            dataIndex: "Addedby",
            key: "Addedby",
        },

    ];
    const adayclick = (event: any = null) => {

        var first = moment();
        var firstday = first.format("DD");
        var firstmonth = first.format("MM");
        var firstyear = first.format("YYYY");
        let fromdate = firstyear + "-" + firstmonth + "-" + firstday;
        setfromdate(moment(fromdate));
        //var new_date = moment().add('days', 1);
        var new_date = moment();
        var day = new_date.format("DD");
        var month = new_date.format("MM");
        var year = new_date.format("YYYY");
        let todate = year + "-" + month + "-" + day;
        settodate(moment(todate));
        setTodayFlag(true);
        setPrevFlag(false);
        onDateSearch(fromdate, todate,);
    };
    const monthclick = () => {
     //   setIsButtonClicked("Month");
        var first = moment();
        var firstmonth = first.format("MM");
        var firstyear = first.format("YYYY");
        let fromdate = firstyear + "-" + firstmonth + "-" + "01";
        setfromdate(moment(fromdate));
        //var new_date = moment().add('days', 1);
        var new_date = moment();
        var day = new_date.format("DD");
        var month = new_date.format("MM");
        var year = new_date.format("YYYY");
        let todate = year + "-" + month + "-" + day;
        settodate(moment(todate));
        setTodayFlag(true);
        setPrevFlag(false);
        onDateSearch(fromdate, todate);
      };

    useEffect(() => {
        // getCustomerList();
        monthclick();
    }, []);
    const onfromdatechange = (value: any) => {
        setfromdate(value);
        try {
            var fromdate = moment(value).format("YYYY/MM/DD");
            let todate = moment().format("YYYY/MM/DD");
            //DateSearch(fromdate, todate);
            setTodayFlag(false);
            setPrevFlag(false);
            //setfromdate(value);
        } catch (ex) {
            console.log(ex);
        }
    };
    const ontodatechange = (value: any) => {
        settodate(value);
        try {
            let startdate = moment(fromdate).format("YYYY/MM/DD");
            //DateSearch(startdate, todate);
            setTodayFlag(false);
            setPrevFlag(false);

            //settodate(moment(todate));
        } catch (ex) {
            console.log(ex);
        }
    };



    return (
        <div className="booking-child-routes">
            <div className="booking-child-routes-button-section">

                <Row style={{ paddingBottom: 10 }}>
                    <Col>
                        <span
                            style={{
                                fontSize: "large",
                                fontWeight: "bold",
                                fontStyle: "Times New Roman",
                            }}
                        >
                        Enterprise Enquiry
                        </span>
                    </Col>
                  
                </Row>

                <Row>

                    <Col flex="auto" span={8} >
                        <span style={{ fontSize: "medium" }}> From:</span>

                        <DatePicker
                            value={fromdate}
                            format={dateFormat}
                            disabledDate={disabledFromDate}
                            onChange={onfromdatechange}
                        />
                        <span style={{ fontSize: "medium" }}> To:</span>

                        <DatePicker
                            //value={todate}
                            value={
                                todayFlag
                                    ? moment()
                                    : prevFlag
                                        ? moment().add("days", -1)
                                        : todate
                            }
                            format={dateFormat}
                            disabledDate={disabledDate}
                            onChange={ontodatechange}
                        />

                    </Col>


                    <Col span={2} offset={1}>
                        <Button
                            className="booking-btn-blockSearch"
                            onClick={() =>
                                onDateSearch(fromdate, todate)
                            }
                            disabled={moment(fromdate).isAfter(moment(todate))}
                        >
                            Search
                        </Button>
                    </Col>
                    <Col span={3} offset={3}>
                        <span style={{ fontSize: "large", fontWeight: "bold" }}>
                            Enquiries :   {customerList.length}
                        </span>
                    </Col>
                    <Col span={3} offset={3}>
                        <Input
                            placeholder="Search Text"
                            className="search"
                            onChange={onSearchchange}
                        />
                    </Col>

                </Row>
                <div>
                    <Spin tip="Loading..." spinning={isLoading}>
                        <AppTable
                            columns={columns}
                            data={copyCustomerList}
                            enablePagination={true}
                            defaultPageSize={100}
                            scroll={{ x: "max-content" }}
                        ></AppTable>
                    </Spin>
                </div>
            </div>
        </div>
    );
};

export default EnterpriseEnquiry;
